import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serverLocation } from 'src/app/globals';
import { TokenService } from '../../shared/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class IssueAuditService {

  constructor(
    private _httpClient: HttpClient,
    private _tokenService: TokenService
  ) { }

  public deleteIssueAuditWrapperAsFinished(guid: string): Observable<Object> {
    return this._httpClient.delete(`${serverLocation}/api/issue-audit/${guid}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    });
  }

  public markIssueAuditWrapperAsCreated(guid: string): Observable<Object> {
    return this._httpClient.get(`${serverLocation}/api/issue-audit/mark-wrapper-as-created/${guid}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    });
  }

  public markIssueAuditWrapperAsFinished(guid: string): Observable<Object> {
    return this._httpClient.get(`${serverLocation}/api/issue-audit/mark-wrapper-as-finished/${guid}`, {
      headers: new HttpHeaders().set('Authorization', `Bearer ${this._tokenService.token}`)
    });
  }
}
